import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';

function Login({ onLogin }) {
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showLoginForm, setShowLoginForm] = useState(false);
  const navigate = useNavigate();

  // References for animation
  const leftPhotoRef = useRef(null);
  const centerPhotoRef = useRef(null);
  const rightPhotoRef = useRef(null);
  const nameRef = useRef(null);
  const locationRef = useRef(null);
  const circleRef = useRef(null);

  useEffect(() => {
    const photos = [rightPhotoRef, leftPhotoRef, centerPhotoRef];
    const others = [nameRef.current, locationRef.current, circleRef.current];

    const animatePolaroids = () => {
      // Remove animation classes
      photos.forEach((ref) => {
        if (ref.current) {
          ref.current.classList.remove('grow', 'visible');
        }
      });

      others.forEach((el) => {
        if (el) {
          el.classList.remove('visible');
        }
      });

      // Step 1: Grow in from a singular point
      photos.forEach((ref, index) => {
        setTimeout(() => {
          if (ref.current) {
            ref.current.classList.add('grow');
          }
        }, 1000 + index * 500);
      });

      // Step 2: Slide to final positions after all grows are complete
      setTimeout(() => {
        photos.forEach((ref) => {
          if (ref.current) {
            ref.current.classList.remove('grow');
            ref.current.classList.add('visible');
          }
        });
      }, 3000);


      // Show login form after animation completes
      setTimeout(() => {
        setShowLoginForm(true);
      }, 4000);
    };

    // Run initially
    animatePolaroids();

  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Use the environment variable for the API endpoint
      const response = await fetch(process.env.REACT_APP_API_ENDPOINT + '/auth', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: name,
          password: password
        }),
      });

      const data = await response.json();
      
      if (response.ok && data.status === "ok") {
        // Authentication successful
        // Store the user's name returned from the API
        const userName = data.name || name; // Use the API-returned name or fallback to input name
        localStorage.setItem('userName', userName);
        onLogin(userName, data.event); // Pass the API-returned name to onLogin
        navigate('/');
      } else {
        // Authentication failed
        setError(data.message || 'Invalid credentials. Please try again.');
      }
    } catch (err) {
      setError('An error occurred. Please try again later.');
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="polaroid-gallery">

        <div className="polaroid left-photo" ref={leftPhotoRef}>
          <img src="/images/couple-ring.jpg" alt="Beach wedding" />
        </div>

        <div className="polaroid center-photo" ref={centerPhotoRef}>
          <img src="/images/couple-together.jpg" alt="Couple at doorway" />
        </div>

        <div className="polaroid right-photo" ref={rightPhotoRef}>
          <img src="/images/couple-laughing.jpg" alt="Wedding bouquet" />
        </div>
      </div>

      {showLoginForm && (
        <div className="login-card">

          <p>Please enter your name and password to access our wedding website.</p>
          
          {error && <div className="error-message">{error}</div>}
          
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Full Name</label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                placeholder="Enter your full name"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Enter password"
              />
            </div>
            
            <button 
              type="submit" 
              className="login-button"
              disabled={loading}
            >
              {loading ? 'Logging in...' : 'Enter Site'}
            </button>
          </form>
        </div>
      )}
    </div>
  );
}

export default Login; 